import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["avatarHash", "email", "displayName", "renderName"];
// @ts-expect-error Library not migrated yet
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { getAvatarUrl } from '../avatarQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AvatarViewer = _ref => {
  let {
      avatarHash,
      email,
      displayName,
      renderName
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    gap: 8,
    children: [/*#__PURE__*/_jsx(UIAvatar, Object.assign({
      displayName: displayName,
      hubSpotUserEmail: email,
      size: "xl",
      src: avatarHash && getAvatarUrl(avatarHash)
    }, props)), renderName && displayName]
  });
};